// Aviso de mensaje nuevo: campanita suave (WebAudio, sin archivos) + título de la pestaña parpadeando.
// El sonido respeta el silencio guardado en este navegador; el parpadeo se detiene al volver al Chat.
const KEY = 'chat-sound-muted';
let muted = localStorage.getItem(KEY) === '1';
let ctx = null; let pending = 0; let blink = null; let baseTitle = null; let lastSound = 0; let onChat = false;
const mutedHandlers = new Set();

// Los navegadores exigen un gesto del usuario antes de reproducir audio: preparamos el contexto en el primero.
const unlock = () => { try { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); if (ctx.state === 'suspended') ctx.resume(); } catch { /* sin audio */ } };
if (typeof window !== 'undefined') {
  window.addEventListener('pointerdown', unlock, { passive: true });
  window.addEventListener('keydown', unlock, { passive: true });
  window.addEventListener('pointerdown', () => { if (onChat && !document.hidden) chatNotify.clear(); }, { passive: true });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && onChat) chatNotify.clear(); });
}

const chime = () => {
  if (!ctx || ctx.state !== 'running') return;
  const t = ctx.currentTime;
  [[659.25, 0], [987.77, 0.13]].forEach(([freq, delay]) => {
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = 'sine'; o.frequency.value = freq;
    g.gain.setValueAtTime(0.0001, t + delay); g.gain.exponentialRampToValueAtTime(0.09, t + delay + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t + delay + 0.45);
    o.connect(g).connect(ctx.destination); o.start(t + delay); o.stop(t + delay + 0.5);
  });
};

const startBlink = () => {
  if (blink) return;
  baseTitle = document.title; let on = false;
  blink = setInterval(() => { on = !on; document.title = on ? `(${pending}) Mensaje nuevo · Inmoblum` : baseTitle; }, 1000);
};

export const chatNotify = {
  isMuted: () => muted,
  setMuted(v) { muted = !!v; localStorage.setItem(KEY, muted ? '1' : '0'); mutedHandlers.forEach((f) => f(muted)); },
  onMuted(fn) { mutedHandlers.add(fn); return () => mutedHandlers.delete(fn); },
  setOnChat(v) { onChat = !!v; if (onChat && !document.hidden) chatNotify.clear(); },
  isOnChat: () => onChat,
  pending: () => pending,
  // Llamar solo con mensajes de otras personas
  onMessage() {
    pending += 1; startBlink();
    if (!muted && Date.now() - lastSound > 1500) { lastSound = Date.now(); chime(); }
  },
  clear() { pending = 0; if (blink) { clearInterval(blink); blink = null; if (baseTitle) document.title = baseTitle; } },
};
